const tooltipHeader = "Net effective rent";

const tooltipText =
  "This figure factors in lease concessions, such as one free month. The amount you pay every month may be higher.";

const tooltipBlogLink =
  "https://streeteasy.com/blog/net-effective-rent-what-does-it-mean-nyc-actual-rent";

export { tooltipHeader, tooltipText, tooltipBlogLink };
